/* eslint-disable no-console */
import { doGet, doPost } from '../utils/request';

export const getAllCategories = async () => {
  try {
    const response = await doGet('/getCategories');
    return response;
  } catch (err: any) {
    return err;
  }
};

export const getFixtures = async (data: any) => {
  try {
    const response = await doPost('/api/xhr', data);
    return response;
  } catch (err: any) {
    return err;
  }
};

export const getTeamFixtures = async (data: any) => {
  try {
    const response = await doPost('/api/getTeamFixtures', data);
    return response;
  } catch (err: any) {
    return err;
  }
};

export const getLeagueFixtures = async (data: any) => {
  try {
    const response = await doPost('/api/getLeagueFixtures', data);
    return response;
  } catch (err: any) {
    return err;
  }
};


export const getdbTeams = async (data: any) => {
  try {
    const response = await doPost('/api/getdbTeams', data);
    return response;
  } catch (err: any) {
    return err;
  }
};

export const getdbLeagues = async (data: any) => {
  try {
    const response = await doPost('/api/getdbLeagues', data);
    return response;
  } catch (err: any) {
    return err;
  }
};

export const getFixtureByName = async (data: any) => {
  try {
    const response = await doPost('/api/xrhs', data);
    return response;
  } catch (err: any) {
    return err;
  }
};

export const getIframe = async (data: any) => {
  try {
    const response = await doPost('/api/getIframe', data);
    return response;
  } catch (err: any) {
    return err;
  }
};

export const getStreamLinks = async (fixture: any) =>{
  const filter = {
    categoryName: fixture?.categoryName,
    subCat: fixture?.subCategoryName,
    teamA: fixture?.game.teamA,
    teamB:  fixture?.game.teamB,
    link: fixture?.game?.sourceLink,
  }
  try {
    const response = await doPost('/api/getLiveStreams', filter);
    return response;
  } catch (err: any) {
    return err;
  }
}

export const sendMail = async (body: any) =>{
  try {
    const response = await doPost('/api/sendMessage', body);
    return response;
  } catch (err: any) {
    return err;
  }
}

export const addStream = async (body: any) =>{
  try {
    const response = await doPost('/api/addStream', body);
    return response;
  } catch (err: any) {
    return err;
  }
}

export const updateStream = async (body: any) =>{
  try {
    const response = await doPost('/api/getLiveStreams', body);
    return response;
  } catch (err: any) {
    return err;
  }
}

export const authenticateUser = async (body: any) =>{
  try {
    const response = await doPost('/api/authenticateUser', body);
    return response;
  } catch (err: any) {
    return err;
  }
}

export const getStandings = async (body: any) =>{
  try {
    const response = await doPost('/api/getStandings', body);
    return response;
  } catch (err: any) {
    return err;
  }
}

export const getBlogs = async () =>{
  try {
    const response = await doPost('/api/blogs', {});
    return response;
  } catch (err: any) {
    return err;
  }
}

export const getBlogById = async (id: string) => {
  if (!id) {
    throw new Error('Blog ID is required');
  }

  try {
    const response = await doGet(`/api/blogs/${id}`);
    return response;
  } catch (error) {
    console.error('getBlogById error:', error);
    throw error; // ⬅️ important
  }
};
